import React from 'react';
import logo from '../../assets/logos/kegstar-logo.png';

function KegstarLogo() {
    // Import result is the URL of your image
    return <img src={logo} alt="Kegstar Logo" style={{width: '75px'}} />;
}

export default KegstarLogo;
